import React, { ReactNode } from 'react'

interface IProps {
  children: ReactNode
}

const InletWrapper = ({ children }: IProps) => (
  <div className='inlet-wrapp'>
    <div className='inlet-inner' data-testid='inlet-wrapper'>
      {children}
    </div>
  </div>
)

export default InletWrapper
